
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calibration",
      function () {
        return require("private-next-pages/calibration.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calibration"])
      });
    }
  